import React, { SVGProps } from 'react';

const EveryDayLowPrice = (props: SVGProps<SVGSVGElement>): JSX.Element => {
  return (
    <svg
      width="16"
      height="16"
      viewBox="0 0 16 16"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className="icon icon--everyDayLowPrice"
      {...props}
    >
      <path
        d="M4.33333 5.33333C4.88562 5.33333 5.33333 4.88562 5.33333 4.33333C5.33333 3.78105 4.88562 3.33333 4.33333 3.33333C3.78105 3.33333 3.33333 3.78105 3.33333 4.33333C3.33333 4.88562 3.78105 5.33333 4.33333 5.33333Z"
        fill={props?.fill || "currentColor"}
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M4.33333 1C2.49238 1 1 2.49238 1 4.33333V7.22876C1 8.11282 1.35119 8.96067 1.97631 9.58579L6.64298 14.2525C7.94472 15.5542 10.0553 15.5542 11.357 14.2525L14.2525 11.357C15.5542 10.0553 15.5542 7.94472 14.2525 6.64298L9.58579 1.97631C8.96067 1.35119 8.11282 1 7.22876 1H4.33333ZM2.33333 4.33333C2.33333 3.22876 3.22876 2.33333 4.33333 2.33333H7.22876C7.7592 2.33333 8.26791 2.54405 8.64298 2.91912L13.3096 7.58579C14.0907 8.36684 14.0907 9.63316 13.3096 10.4142L10.4142 13.3096C9.63316 14.0907 8.36683 14.0907 7.58578 13.3096L2.91912 8.64298C2.54405 8.26791 2.33333 7.7592 2.33333 7.22876V4.33333Z"
        fill={props?.fill || "currentColor"}
      />
      <path
        d="M10 6H8.5V5.33333H7.5V6H7C6.35567 6 5.83333 6.52233 5.83333 7.16667V7.33333C5.83333 7.97767 6.35567 8.5 7 8.5H9C9.09205 8.5 9.16667 8.57462 9.16667 8.66667V8.83333C9.16667 8.92538 9.09205 9 9 9H6V10H7.5V10.6667H8.5V10H9C9.64433 10 10.1667 9.47767 10.1667 8.83333V8.66667C10.1667 8.02233 9.64433 7.5 9 7.5H7C6.90795 7.5 6.83333 7.42538 6.83333 7.33333V7.16667C6.83333 7.07462 6.90795 7 7 7H10V6Z"
        fill={props?.fill || "currentColor"}
      />
    </svg>
  );
};

EveryDayLowPrice.displayName = 'EveryDayLowPrice';

export default EveryDayLowPrice;
